var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1FAB5883-D556-4772-89D0-6F251FBEC649") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ecosystem-list",
    transform: "translate(-1429.000000, -43.000000)",
    stroke: "#76888F",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1430.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.56,20.73 C21.56,18.6810236 19.8989764,17.02 17.85,17.02 L10.43,17.02 C9.44604682,17.02 8.50239381,17.4108739 7.80663384,18.1066338 C7.11087388,18.8023938 6.72,19.7460468 6.72,20.73",
    id: "_Path_6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_Path_7",
    cx: 14.14,
    cy: 9.6,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.14,
    cy: 14.24,
    r: 13.62
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.e493807513510efca57f294b6a62a16a.svg";
export { ForwardRef as ReactComponent };